import { useEffect, useState } from 'react';
import config from '../../common/config';
import SvgMovie from '../../../components/SvgMovie';

import './styles/Digest13.less';

let timeoutDelayPlay: any = null;
let timeoutPlayText: any = null;
const Digest = ({ seq, play = false, onDataLoaded }: any) => {
  const [delayPlay, setDelayPlay] = useState(false);
  const [playText, setPlayText] = useState(false);
  useEffect(() => {
    if (timeoutDelayPlay) {
      clearTimeout(timeoutDelayPlay);
      timeoutDelayPlay = null;
    }
    if (timeoutPlayText) {
      clearTimeout(timeoutPlayText);
      timeoutPlayText = null;
    }

    if (play) {
      timeoutDelayPlay = setTimeout(() => {
        setDelayPlay(true);
      }, 300);

      timeoutPlayText = setTimeout(() => {
        setPlayText(true);
      }, 500);
    } else {
      // 恢复初始化状态
      setDelayPlay(false);
      setPlayText(false);
    }
  }, [play]);

  return (
    <div className={`digest-wrapper digest-wrapper-${seq}`}>
      <SvgMovie
        className="full-screen-svg"
        src={config.slides[seq].svgMovie}
        play={delayPlay}
        onDataLoaded={onDataLoaded}
      />
      <div className={`digest digest-${seq}`}>
        <div className={`text-block ${playText ? 'ani-fade-in' : ''}`}>
          <SvgMovie
            className="svg-in-block"
            src={config.getFullUrl('svg/percent-20.json')}
            play={playText}
          />
          <div className="titles">
            <div className="title title-primary">性能提升</div>
          </div>
          <div className="description">
            <div>
              Token —— <span className="highlight">Make it</span>
            </div>
            <div>
              Lint —— <span className="highlight">Review it</span>
            </div>
            <div>
              Build —— <span className="highlight">Prove it</span>
            </div>
            <div>确保我们的代码轻量且健壮，从而达到性能提升。 </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Digest;
